import eight from "../assets/svg/projects/one.svg";


export const projectsData = [
  {
    id: 1,
    projectName: "Wave Guru",
    projectDesc:
      "Surf Forecast Mobile App that connects with data from WindGuru.",
    tags: ["React Native", "Expo", "Node JS"],
    code: "https://github.com/calher99/wave-guru",
    demo: "null",
    image: "https://i.ibb.co/KXbjytn/Screenshot-2023-08-17-at-00-00-13.png",
  },
  {
    id: 2,
    projectName: "Petit Elegance",
    projectDesc:
      "Ongoing freelancing project for an e-commerce app. Displayed test version with payments included.",
    tags: ["Next.js", "Sanity", "Stripe"],
    code: "null",
    demo: "https://petite-elegance-test.vercel.app/",
    image: "https://i.ibb.co/ygZb108/Screenshot-2023-11-23-at-18-28-49.png",
  },
  {
    id: 3,
    projectName: "Song Notify",
    projectDesc:
      "Notifies you when a new song has been added to any playlist, lets you play those songs and add them to any of your playlists.",
    tags: ["React", "Express", "Material UI"],
    code: "https://github.com/calher99/Spotify-React-newSongNotify",
    demo: "https://new-song-notify.vercel.app/",
    image: "https://i.ibb.co/Yf8XcBm/Screenshot-2023-08-21-at-14-23-15.png",
  },
  {
    id: 4,
    projectName: "Meeting Pricer",
    projectDesc: "Displays the cost of a meeting (my father needed something to convince his boss of useless meetings...).",
    tags: ["React", "CSS", "Material Ui"],
    code: "https://github.com/calher99/MeetingPricer",
    demo: "https://meeting-pricer-acc5rk07s-calher99-gmailcom.vercel.app/",
    image: eight,
  },
];

// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/
